export const sum = (items: number[]): number => {
  let sum: number = 0;
  for (let i = 0; i < items.length; i++) {
    sum += items[i];
  }
  return sum;
};

export const max = (items: number[]): null | number => {
  return items.length > 0 ? Math.max(...items) : null;
};
